import { render } from "./GradeCoursesView.vue?vue&type=template&id=4b8e3cbc&scoped=true"
import script from "./GradeCoursesView.vue?vue&type=script&lang=js"
export * from "./GradeCoursesView.vue?vue&type=script&lang=js"

import "./GradeCoursesView.vue?vue&type=style&index=0&id=4b8e3cbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8e3cbc"]])

export default __exports__